import { forwardRef, type Ref, type SVGProps } from "react";
const IconRevealOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M18.9 15.1a3 3 0 0 1 .1.9 3 3 0 1 1-3-3 3 3 0 0 1 .9.1 1.5 1.5 0 0 0-.9 1.4 1.5 1.5 0 0 0 1.5 1.5 1.5 1.5 0 0 0 1.4-.9" />
    <path d="M29.5 14.7C24.7 9 20.1 7 16.1 7 9.7 7 4.7 12 2.5 14.7a2 2 0 0 0 0 2.6C7.3 23 11.9 25 15.9 25c6.4 0 11.4-5 13.6-7.7a2 2 0 0 0 0-2.6M4 16a24 24 0 0 1 5.9-5.2 8 8 0 0 0 .1 10.5A23.2 23.2 0 0 1 4 16m12 6a6 6 0 1 1 6-6 6 6 0 0 1-6 6m6.1-.9a8 8 0 0 0-.1-10.4 23.2 23.2 0 0 1 6 5.3 24 24 0 0 1-5.9 5.1" />
  </svg>
);
const ForwardRef = forwardRef(IconRevealOutlineSVG);
ForwardRef.displayName = "IconRevealOutline";
export { ForwardRef as IconRevealOutline };
